module.exports = __webpack_public_path__ + "img/Tessellate32.06bf3ec1.jpg";